<template>
  <div class="main" :class="{center: details_expanded || creatingProfile}">
    <div class="profile-wrapper">
      <div class="select-container" v-if="!details_expanded">
        <select name="selected-pool" id="selected-pool" v-model="selectedPool" @change="getProfile(selectedPool.pool_id)" :disabled="creatingProfile">
          <option v-for="pool in pools" :value="pool" :key="pool.pool_id">{{ pool.name }}</option>
        </select>
      </div>
      <LoadingSpinner v-if="profileLoading" message="Profil lädt..."/>
      <div v-if="noProfileYet && !creatingProfile" class="add_profile_wrapper">
        <h3>Du hast noch keinen Spielernamen in dieser Gruppe.</h3>
        <button class="add_profile" @click="creatingProfile = true; details_expanded = !details_expanded;">Namen vergeben</button>
      </div>
      <div v-if="!pools_available" class="add_profile_wrapper">
        <h3>Du bist noch kein Mitglied in einer Gruppe!</h3>
        <p>Tritt auf der Startseite zuerst einer Gruppe bei.</p>
      </div>
      <div class="match-selection-container" :class="{details_expanded: details_expanded}" v-if="(!noProfileYet || creatingProfile) && pools_available && !profileLoading">
        <div class="match-info" v-if="!details_expanded && !creatingProfile">
          <h2 id="profile">{{profile.name}}</h2>
          <button class="edit-btn" @click="details_expanded = !details_expanded; profile.new_name = profile.name">Bearbeiten</button>
        </div>
        <div class="match-info edit" v-if="details_expanded || creatingProfile" :class="{ disabled_loading: submitting }"> <!-- ***** edit view here *****-->
          <LoadingSpinner class="submitting" v-if="submitting" message="Profil wird gespeichert..."/>
          <div style="display: flex; flex-direction: column; align-items: start; gap: 15px;">
            <input type="text" id="profile-name" v-model="profile.new_name" placeholder="Dein Name">
            <p v-if="nameSuggestion" class="suggestion-info">💡 Vorschlag aus "{{nameSuggestionPool}}": <b>{{nameSuggestion}}</b></p>
            <p class="profile-more-info">Du kannst pro Gruppe einen separaten Namen vergeben.</p>

          </div>
          <div class="submit-buttons">
            <button class="edit-btn logout" @click="creatingProfile = false; details_expanded = false;">Abbrechen</button>
            <button class="edit-btn" @click="submitProfile()">Speichern</button>
          </div>
        </div>
      </div>
    </div>
    <div class="settings-section" v-if="!details_expanded">
      <h3>Einstellungen</h3>
      <div class="setting-item frosted">
        <p>Erscheinungsbild</p>
        <button class="theme-icon-toggle" @click="toggleDarkMode">
          <img src="../assets/images/toggle-dark-mode.svg" alt="Toggle Theme">
        </button>
      </div>
      <div class="setting-item frosted" v-if="isAdmin">
        <p>Admin Dashboard</p>
        <router-link to="/admin" class="theme-toggle" style="text-decoration: none;">Öffnen</router-link>
      </div>
      <div class="setting-item frosted" v-if="isAdmin">
        <p>H-Spiel</p>
        <router-link to="/h-game/" class="theme-toggle" style="text-decoration: none;">H-Spiel</router-link>
      </div>

      <div class="setting-item frosted password-change-container">
        <div class="setting-header" @click="showPasswordChange = !showPasswordChange" style="cursor: pointer; width: 100%;">
          <p>Passwort ändern</p>
          <button class="theme-icon-toggle">
            <template v-if="!showPasswordChange">
              <img src="../assets/images/pen.svg" alt="Ändern">
            </template>
            <template v-else>
              <img src="../assets/images/back.svg" style="margin-left: 8px;" alt="Abbrechen">
            </template>
          </button>
        </div>
        
        <div v-if="showPasswordChange" class="password-form">
          <input type="password" v-model="passwords.current" placeholder="Aktuelles Passwort">
          <input type="password" v-model="passwords.new" placeholder="Neues Passwort">
          <input type="password" v-model="passwords.repeat" placeholder="Neues Passwort wiederholen">
          <p v-if="passwordMsg" class="password-msg" :class="{ error: passwordError, success: !passwordError }">{{ passwordMsg }}</p>
          <button class="submit-password" @click="submitPasswordChange" :disabled="submittingPassword">
            {{ submittingPassword ? 'Speichert...' : 'Passwort speichern' }}
          </button>
        </div>
      </div>

      <h3 style="margin-top: 30px;">Rechtliches</h3>
      <div class="legal-links">
        <router-link to="/terms-of-service" class="setting-item frosted legal-link">
          <p>AGB</p>
          <img src="@/assets/images/back.svg" class="arrow-right">
        </router-link>
        <router-link to="/privacy-policy" class="setting-item frosted legal-link">
          <p>Datenschutz</p>
          <img src="@/assets/images/back.svg" class="arrow-right">
        </router-link>
        <router-link to="/withdrawal" class="setting-item frosted legal-link">
          <p>Widerrufsbelehrung</p>
          <img src="@/assets/images/back.svg" class="arrow-right">
        </router-link>
      </div>
    </div>
    <button class="logout frosted" style="margin-bottom: 40px;" @click="logout" v-if="!details_expanded">Logout</button>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from 'moment';
export default {
  "name": "AccountView",
  data() {
    return {
      isAdmin: false,
      isDarkMode: document.documentElement.getAttribute('data-theme') === 'dark',
      pools: null,
      pools_available: false,
      details_expanded: false,
      noProfileYet: false,
      profileLoading: false,
      uploadingImage: false,
      submitting: false,
      creatingProfile: false,
      availability_options : [
        {name: 'Mo', code: 'mo'},
        {name: 'Di', code: 'di'},
        {name: 'Mi', code: 'mi'},
        {name: 'Do', code: 'do'},
        {name: 'Fr', code: 'fr'},
        {name: 'Sa', code: 'sa'},
        {name: 'So', code: 'so'}
      ],
      profile: {
        name: null,
        new_name: null,
        birthday: null,
        height: null,
        looking_for: null,
        availability: [],
        short_bio: null,
        long_bio: null
      },
      fileToUpload: null,
      showPasswordChange: false,
      submittingPassword: false,
      passwordMsg: null,
      passwordError: false,
      passwords: {
        current: '',
        new: '',
        repeat: ''
      },
      nameSuggestion: null,
      nameSuggestionPool: null
    }
  },


  computed: {
    selectedPool: {
      get() {
        return this.$store.getters.getSelectedPool;
      },
      set(val) {
        this.$store.commit('SET_SELECTED_POOL', val);
      }
    }
  },
  components: {
    LoadingSpinner
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      const theme = this.isDarkMode ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
    },
    async submitPasswordChange() {
      if (!this.passwords.current || !this.passwords.new || !this.passwords.repeat) {
        this.passwordError = true;
        this.passwordMsg = "Bitte alle Felder ausfüllen.";
        return;
      }

      if (this.passwords.new !== this.passwords.repeat) {
        this.passwordError = true;
        this.passwordMsg = "Die neuen Passwörter stimmen nicht überein.";
        return;
      }

      if (this.passwords.new.length < 6) {
        this.passwordError = true;
        this.passwordMsg = "Das neue Passwort muss mindestens 6 Zeichen lang sein.";
        return;
      }

      this.submittingPassword = true;
      this.passwordMsg = null;

      try {
        const response = await AuthService.changePassword({
          currentPassword: this.passwords.current,
          newPassword: this.passwords.new
        });

        if (response.success) {
          this.passwordError = false;
          this.passwordMsg = "Passwort erfolgreich geändert!";
          this.passwords = { current: '', new: '', repeat: '' };
          setTimeout(() => {
            this.showPasswordChange = false;
            this.passwordMsg = null;
          }, 2000);
        } else {
          this.passwordError = true;
          this.passwordMsg = response.msg || "Fehler beim Ändern des Passworts.";
        }
      } catch (error) {
        this.passwordError = true;
        this.passwordMsg = error.response?.data?.msg || "Ein Fehler ist aufgetreten.";
      } finally {
        this.submittingPassword = false;
      }
    },
    async onFileChange(file) {
      this.fileToUpload = file

      const formData = new FormData();
      formData.append('image', this.fileToUpload);
      formData.append('pool_id', this.selectedPool.pool_id);

      try {
        this.uploadingImage = true
        let result = await AuthService.uploadImage(formData, {headers: {'Content-Type': 'multipart/form-data'}})
        this.uploadingImage = false
        if(result.success) {
          this.profile.images = await this.buildImageArray(this.profile.profile_id)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async removeImage(image_id){
      let response = await AuthService.removeImage({image_id: image_id})
      if(response.success) {
        this.profile.images = this.profile.images.filter(i => i.image_id !== image_id)
      } else {
        console.error(response.msg)
      }
    },
    async submitProfile() {
      this.submitting = true

      let data = {
        ...this.profile,
        name: this.profile.new_name,
        availability: JSON.stringify(this.profile.availability),
        pool_id: this.selectedPool.pool_id
      }

      let msg = await AuthService.submitUserProfile(data)
      if(msg.success) {
        this.$router.go()
      }
      this.submitting = false
    },
    async getUserJoinedPools() {
      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.pools = this.msg.msg
          if(this.pools.length > 0) this.pools_available = true
          
          // Check if previously selected pool is still available
          const persistedPool = this.selectedPool;
          if (persistedPool) {
            const found = this.pools.find(p => p.pool_id === persistedPool.pool_id);
            if (found) {
              this.selectedPool = found;
              await this.getProfile(this.selectedPool.pool_id);
              return;
            }
          }
          
          this.selectedPool = this.pools[0]
          await this.getProfile(this.selectedPool.pool_id)
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
    },
    async getProfile(pool_id) {
      if(!pool_id) return

      this.profileLoading = true

      try {
        this.msg = await AuthService.getUserProfileFromPool({pool_id: pool_id})
        if (this.msg.success) {
          if(this.msg.msg.length > 0) {
            this.profile = {...this.msg.msg[0], "age": Math.floor(moment().diff(moment(this.msg.msg[0].birthday), 'days') / 365),
              "birthday": moment(this.msg.msg[0].birthday).format("YYYY-MM-DD"),
              "availability": this.msg.msg[0].availability ? JSON.parse(this.msg.msg[0].availability) : [],
              "images": await this.buildImageArray(this.msg.msg[0].profile_id)
            }
            console.log(this.profile)
            this.noProfileYet = false
            this.nameSuggestion = null
            this.nameSuggestionPool = null
          } else {
            this.noProfileYet = true
            // If No Profile, check if there's a last used name to suggest
            const suggestion = await AuthService.getLastUsedName()
            if (suggestion.success) {
              this.nameSuggestion = suggestion.name
              this.nameSuggestionPool = suggestion.pool_name
              this.profile.new_name = suggestion.name
            }
          }
        }

      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }

      this.profileLoading = false
    },
    async buildImageArray(profile_id) {
      const result = await AuthService.getProfileImages({ profile_id });

      if (!result.success) return [];

      const imagePromises = result.msg.map(async image_id => {
        try {
          const img = await AuthService.getImage({ image_id: image_id.image_id });
          return URL.createObjectURL(img);
        } catch (error) {
          if (error.response && error.response.status === 404) {
            console.warn(`Bild mit ID ${image_id.image_id} nicht gefunden (404).`);
            return null; // Optional: Fallback-Bild-URL hier zurückgeben
          } else {
            console.error(`Fehler beim Laden des Bildes ${image_id.image_id}:`, error);
            return null;
          }
        }
      });

      let response = await Promise.all(imagePromises);
      return response
    },
    openUploadDialog(){
      let input = document.createElement('input');
      input.type = 'file';
      input.onchange = () => {
        let files = Array.from(input.files);
        this.onFileChange(files[0])
      };
      input.click();
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.availability_options.push(tag)
      this.profile.availability.push(tag)
    }
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg.isAdmin;
    } catch(e){
      console.error(e)
    }

    await this.getUserJoinedPools()
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tag, .multiselect__option--highlight {
  background: var(--primary-color) !important;
}
</style>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  background: var(--background);
  padding: 20px;
  overflow-y: auto;
}

.main.center {
  justify-content: center;
}

h1, h2 {
  margin: 0;
  font-weight: 600;
}

h1 {
  font-size: 2rem;
  margin-bottom: 20px;
}

h3 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

p {
  color: var(--tertiary-color);
  margin-bottom: 20px;
}

button {
  font-family: var(--font);
  color: var(--background);
  background: var(--primary-color);
  border: none;
  font-weight: 600;
  font-size: 1rem;
  border-radius: var(--radius-l);
  padding: 16px 32px;
  align-self: center;
  cursor: pointer;
  transition: opacity 0.2s;
}

button:active {
  opacity: 0.8;
}

button.edit-btn {
  width: 100%;
}

button.logout {
  background: var(--background-secondary);
  color: var(--warning);
  margin-top: 40px;
  width: 100%;
  max-width: 400px;
}

.settings-section {
  width: 100%;
  max-width: 400px;
  margin-top: 40px;
  text-align: left;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--background-secondary);
  padding: 15px 20px;
  border-radius: var(--radius-m);
}

.setting-item p {
  margin: 0;
  color: var(--primary-color);
  font-weight: 500;
}

.theme-toggle {
  background: var(--primary-color) !important;
  color: var(--background) !important;
  padding: 8px 16px !important;
  font-size: 0.9rem !important;
  border-radius: var(--radius-s) !important;
}

.theme-icon-toggle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--background-secondary);
  border: 1px solid var(--border-color);
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
  padding: 0;
}

.theme-icon-toggle img {
  width: 24px !important;
  height: 24px !important;
  filter: var(--icon-filter);
  opacity: 1 !important;
  transform: none !important;
  margin: 0;
}

.theme-icon-toggle:active {
  transform: scale(0.95);
}

.password-change-container {
  flex-direction: column;
  align-items: stretch !important;
  gap: 15px;
}

.setting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.password-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--border-color);
}

.password-form input {
  background: var(--background);
  border: 1px solid var(--border-color);
  padding: 12px;
  border-radius: var(--radius-s);
  color: var(--primary-color);
  font-family: var(--font);
}

.submit-password {
  padding: 10px !important;
  font-size: 0.9rem !important;
  margin-top: 5px;
}

.password-msg {
  font-size: 0.85rem;
  margin: 5px 0;
}

.password-msg.error {
  color: var(--warning);
}

.password-msg.success {
  color: var(--success);
}

.legal-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legal-link {
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;
}

.legal-link:active {
  background: var(--background-secondary-hover);
}

.arrow-right {
  transform: rotate(180deg);
  width: 16px;
  height: 16px;
  opacity: 0.5;
  filter: var(--icon-filter);
}

/* Select */
#selected-pool {
  font-size: 1.5rem;
  font-family: var(--font);
  font-weight: 700;
  background: none;
  border: none;
  color: var(--primary-color);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  text-align: center;
  text-align-last: center;
}

.select-container {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.select-container img {
  transform: rotate(-90deg);
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

.profile-wrapper {
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.match-selection-container {
  width: 100%;
  background: none;
  padding: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
}

.match-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
  text-align: center;
  background: none !important;
}

.match-info h2 {
  font-size: 2.5rem;
  margin-bottom: 5px;
}

.match-stat {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  background: var(--background-secondary);
  padding: 10px 20px;
  border-radius: var(--radius-m);
  width: 100%;
  justify-content: center;
}

.match-info input {
  font-size: 1.1rem;
  border: none;
  background: transparent;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
}

.match-info img {
  width: 24px;
  height: 24px;
  opacity: 0.6;
}

/* Edit Form */
.match-info.edit {
  align-items: stretch;
}

.match-info.edit input[type="text"],
.match-info.edit input[type="date"],
.match-info.edit input[type="number"] {
  background: var(--background-secondary);
  padding: 15px;
  border-radius: var(--radius-m);
  text-align: left;
  font-family: var(--font);
  color: var(--primary-color);
}

.match-info.edit .match-stat {
  justify-content: flex-start;
  padding: 0;
  background: none;
  gap: 0;
}

.match-info.edit .match-stat img {
  margin-left: 15px;
  margin-right: 18px;
}

.match-info.edit .match-stat input {
  background: var(--background-secondary);
  padding: 15px;
  border-radius: var(--radius-m);
  text-align: left;
  flex-grow: 1;
}

.submit-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.submit-buttons button {
  flex: 1;
  padding: 16px;
}

.submit-buttons button.logout {
  margin-top: 0;
  background: var(--background-secondary);
  color: var(--primary-color);
}

.add_profile_wrapper {
  margin-top: 100px;
  text-align: center;
}

.add_profile {
  margin-top: 20px;
}

.suggestion-info {
  font-size: 0.85rem;
  color: var(--primary-color);
  background: var(--background-secondary);
  padding: 8px 12px;
  border-radius: var(--radius-s);
  margin-top: -10px;
  opacity: 0.8;
}

.suggestion-info b {
  color: var(--primary-color);
}
</style>

